// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification-toolbar[data-v-cd0d5baa] {\n    display: flex;\n    justify-content: space-between;\n}\n.form-settings[data-v-cd0d5baa] {\n    padding-left: 20px;\n}\n.schedule-field[data-v-cd0d5baa] {\n    display: flex;\nlabel {\n        margin-right: 5px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
